var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgEnsoLogo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 12H9.74785V6.19331C9.74893 5.67522 9.6503 5.16208 9.45766 4.68368C9.07244 3.75805 8.35791 3.02031 7.4614 2.62257C6.77348 2.3208 6.01375 2.23883 5.28027 2.38724C4.54679 2.53566 3.87323 2.90764 3.34652 3.45518C3.00642 3.81111 2.73302 4.22892 2.54011 4.68753C2.34791 5.16606 2.24929 5.67912 2.24992 6.19716V12H1.89702e-05V6.19331C-0.00200271 5.36583 0.157585 4.54642 0.469245 3.78407C1.07419 2.29385 2.22187 1.10862 3.66506 0.483673C4.40429 0.164408 5.19759 0 5.99888 0C6.80018 0 7.59348 0.164408 8.33271 0.483673C9.77581 1.10901 10.9236 2.29409 11.5293 3.78407C11.8415 4.54631 12.0016 5.36572 12 6.19331V12Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.20368 9.77965C7.93209 9.77965 8.52258 9.16997 8.52258 8.4179C8.52258 7.66583 7.93209 7.05615 7.20368 7.05615C6.47526 7.05615 5.88477 7.66583 5.88477 8.4179C5.88477 9.16997 6.47526 9.77965 7.20368 9.77965Z",
    fill: "currentColor"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEnsoLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/enso-logo.6965717c.svg";
export { ForwardRef as ReactComponent };